import clsx from 'clsx';
import React from 'react';

const FormActionsWrapper = ({ className, children }) => {
  return <div className={clsx(className, 'mt-8 flex justify-center')}>{children}</div>;
};

export default FormActionsWrapper;
